import { Components, Theme } from "@mui/material";

export const MuiLink: Components<Theme>["MuiLink"] = {
  styleOverrides: {
    button: ({ theme }) => ({
      ":hover": { color: theme.newColors.theme.blue500 },
    }),
  },
};
